import React, { FC, useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";

import ProjectPageShell, { Crumb } from "../shared/ProjectPageShell";
import CalendarViewModal from "./CalendarModal/modal";
import { calendarApis } from "../../../api/Calendar";

const CalendarDetailPage: FC = () => {
  const { calendarId } = useParams<{ calendarId: string }>();
  const location = useLocation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [calendarData, setCalendarData] = useState<any>(null);

  // Get data from location state
  const locationState = location.state as any;
  const initialTab = locationState?.tab || "view";

  // Fetch calendar details
  useEffect(() => {
    const fetchCalendarDetails = async () => {
      if (!calendarId) return;

      setLoading(true);
      try {
        const response = await calendarApis.getCalendarById(calendarId);
        if (response?.status && response?.data) {
          setCalendarData(response.data);
        }
      } catch (error) {
        console.error("Error fetching calendar details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCalendarDetails();
  }, [calendarId]);

  // Handle navigation back to calendar list
  const handleBackToCalendarList = () => {
    navigate("/pms/calendar");
  };

  // Refresh data
  const refreshData = async () => {
    if (!calendarId) return;
    try {
      const response = await calendarApis.getCalendarById(calendarId);
      if (response?.status && response?.data) {
        setCalendarData(response.data);
      }
    } catch (error) {
      console.error("Error refreshing calendar details:", error);
    }
  };

  const calendarTitle = calendarData?.calendarTitle || locationState?.calendarTitle || "Calendar";

  const breadcrumb: Crumb[] = [
    { label: "Calendars", onClick: handleBackToCalendarList },
    { label: calendarTitle },
  ];

  return (
    <ProjectPageShell
      headTitle={`${calendarTitle} - Calendar Details`}
      breadcrumb={breadcrumb}
      title={calendarTitle}
      eyebrow="Calendar"
      onBack={handleBackToCalendarList}
      loading={loading}
    >
      {calendarData && (
        <CalendarViewModal
          fullData={{ data: calendarData, tab: initialTab }}
          refresh={refreshData}
        />
      )}
    </ProjectPageShell>
  );
};

export default CalendarDetailPage;
